<app-header></app-header>
<app-left-panel></app-left-panel>
<!-- <app-breadcrumb></app-breadcrumb> -->
<router-outlet></router-outlet>
<div class="clearfix"></div>
<app-footer></app-footer>